var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueCroppie',{ref:"croppie",staticClass:"common-image-crop",attrs:{"enableResize":false,"showZoomer":true,"viewport":{ width: 300, height: 300 }},on:{"update":_vm.cropDebounced}})}
var staticRenderFns = []

export { render, staticRenderFns }